export interface CreateTableFromAIProgressUpdate {
  elapsedTime: number;
  status: string;
  tableId?: string;
  error?: string;
}

export class CreateTableFromAIAPI {
  private static readonly BASE_URL = "/api/v1";
  private static readonly ENDPOINTS = {
    createTableFromAI: "/tools/create_table_from_ai",
  } as const;

  static createTableFromAI(
    userPrompt: string,
    onProgress: (update: CreateTableFromAIProgressUpdate) => void,
  ): EventSource {
    const encodedPrompt = encodeURIComponent(userPrompt);
    const url = `${this.BASE_URL}${this.ENDPOINTS.createTableFromAI}?userPrompt=${encodedPrompt}`;

    const eventSource = new EventSource(url, {
      withCredentials: true,
    });

    eventSource.onmessage = (event) => {
      try {
        const update: CreateTableFromAIProgressUpdate = JSON.parse(event.data);
        onProgress(update);

        // Close the connection when completed or error
        if (update.status === "completed" || update.status === "error") {
          eventSource.close();
        }
      } catch (error) {
        console.error("Failed to parse SSE data:", error);
        onProgress({
          elapsedTime: 0,
          status: "error",
          error: "Failed to parse response",
        });
        eventSource.close();
      }
    };

    eventSource.onerror = (error) => {
      console.error("SSE error:", error);
      onProgress({
        elapsedTime: 0,
        status: "error",
        error: "Connection error",
      });
      eventSource.close();
    };

    return eventSource;
  }
}
